import React from "react";

import { ACTIVITY_TYPES } from "Constants/constants";
import {
  gitProjectSelector,
  orgByProjectIdSelector
} from "Reducers/project/project";
import { useAppSelector } from "Store/hooks";

import Activity from "./Activity/Activity";
import activityTemplates from "./activityTemplates";

const ActivityItem = (
  props: React.ComponentProps<typeof Activity> & { shouldForceLoader?: boolean }
) => {
  const { type } = props.activity;
  const activityTemplate = activityTemplates[type] || activityTemplates.unknown;

  const organizationId = useAppSelector(state =>
    orgByProjectIdSelector(state, {
      projectId: props.activity.project
    })
  );
  const project = useAppSelector(state =>
    gitProjectSelector(state, {
      organizationId,
      projectId: props.activity.project
    })
  );
  let activityDetails:
    | undefined
    | { activityTitle: string; activityId: string } = undefined;

  if (type === ACTIVITY_TYPES.ENVIRONMENT.SYNCHRONIZE) {
    activityDetails = {
      activityTitle: props.activity?.payload?.outcome?.title,
      activityId: props.activity?.payload?.outcome?.id
    };
  } else if (props.activity?.payload?.environment?.title) {
    activityDetails = {
      activityTitle: props.activity?.payload?.environment?.title,
      activityId: props.activity?.payload?.environment?.id
    };
  }

  props = { ...props, organizationId } as React.ComponentProps<
    typeof Activity
  > & { organizationId: string };

  return (
    <Activity
      {...props}
      icon={activityTemplate.icon}
      title={
        activityTemplate.title
          ? activityTemplate.title({ ...props, projectTitle: project?.title })
          : undefined
      }
      cancelTitle={
        activityTemplate.cancelTitle
          ? activityTemplate.cancelTitle(props)
          : undefined
      }
      activityDetails={activityDetails}
      notification={activityTemplate.notification}
    />
  );
};

export default ActivityItem;
